import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  Upload: any;
};

export type AuthenticatedItem = User;

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilter>;
};

export type Clothe = {
  __typename?: 'Clothe';
  description?: Maybe<Scalars['String']>;
  description_translations?: Maybe<Array<TranslatedText>>;
  description_translationsCount?: Maybe<Scalars['Int']>;
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFieldOutput>;
  mobility?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  name_translations?: Maybe<Array<TranslatedText>>;
  name_translationsCount?: Maybe<Scalars['Int']>;
  originalID?: Maybe<Scalars['String']>;
  protection?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  warmth?: Maybe<Scalars['Float']>;
  waterproof?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  windproof?: Maybe<Scalars['Float']>;
};


export type ClotheDescription_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type ClotheDescription_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type ClotheGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type ClotheGameCountArgs = {
  where?: GameWhereInput;
};


export type ClotheName_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type ClotheName_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};

export type ClotheCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  image?: InputMaybe<ImageFieldInput>;
  mobility?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  protection?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  warmth?: InputMaybe<Scalars['Float']>;
  waterproof?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
  windproof?: InputMaybe<Scalars['Float']>;
};

export type ClotheOrderByInput = {
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  mobility?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
  protection?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  warmth?: InputMaybe<OrderDirection>;
  waterproof?: InputMaybe<OrderDirection>;
  weight?: InputMaybe<OrderDirection>;
  windproof?: InputMaybe<OrderDirection>;
};

export type ClotheUpdateArgs = {
  data: ClotheUpdateInput;
  where: ClotheWhereUniqueInput;
};

export type ClotheUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  image?: InputMaybe<ImageFieldInput>;
  mobility?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  protection?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  warmth?: InputMaybe<Scalars['Float']>;
  waterproof?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
  windproof?: InputMaybe<Scalars['Float']>;
};

export type ClotheWhereInput = {
  AND?: InputMaybe<Array<ClotheWhereInput>>;
  NOT?: InputMaybe<Array<ClotheWhereInput>>;
  OR?: InputMaybe<Array<ClotheWhereInput>>;
  description?: InputMaybe<StringFilter>;
  description_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  game?: InputMaybe<GameManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  mobility?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  name_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  originalID?: InputMaybe<StringFilter>;
  protection?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  warmth?: InputMaybe<FloatNullableFilter>;
  waterproof?: InputMaybe<FloatNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
  windproof?: InputMaybe<FloatNullableFilter>;
};

export type ClotheWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CreateInitialUserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type FirstAid = {
  __typename?: 'FirstAid';
  description?: Maybe<Scalars['String']>;
  description_translations?: Maybe<Array<TranslatedText>>;
  description_translationsCount?: Maybe<Scalars['Int']>;
  effect_description?: Maybe<Scalars['String']>;
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']>;
  name_translations?: Maybe<Array<TranslatedText>>;
  name_translationsCount?: Maybe<Scalars['Int']>;
  originalID?: Maybe<Scalars['String']>;
  prevents_description?: Maybe<Scalars['String']>;
  treats_description?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};


export type FirstAidDescription_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type FirstAidDescription_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type FirstAidGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type FirstAidGameCountArgs = {
  where?: GameWhereInput;
};


export type FirstAidName_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type FirstAidName_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};

export type FirstAidCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  effect_description?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  prevents_description?: InputMaybe<Scalars['String']>;
  treats_description?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type FirstAidOrderByInput = {
  description?: InputMaybe<OrderDirection>;
  effect_description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
  prevents_description?: InputMaybe<OrderDirection>;
  treats_description?: InputMaybe<OrderDirection>;
  weight?: InputMaybe<OrderDirection>;
};

export type FirstAidUpdateArgs = {
  data: FirstAidUpdateInput;
  where: FirstAidWhereUniqueInput;
};

export type FirstAidUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  effect_description?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  prevents_description?: InputMaybe<Scalars['String']>;
  treats_description?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type FirstAidWhereInput = {
  AND?: InputMaybe<Array<FirstAidWhereInput>>;
  NOT?: InputMaybe<Array<FirstAidWhereInput>>;
  OR?: InputMaybe<Array<FirstAidWhereInput>>;
  description?: InputMaybe<StringFilter>;
  description_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  effect_description?: InputMaybe<StringFilter>;
  game?: InputMaybe<GameManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  name_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  originalID?: InputMaybe<StringFilter>;
  prevents_description?: InputMaybe<StringFilter>;
  treats_description?: InputMaybe<StringFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type FirstAidWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type Food = {
  __typename?: 'Food';
  calories?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  description_translations?: Maybe<Array<TranslatedText>>;
  description_translationsCount?: Maybe<Scalars['Int']>;
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  hydration?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']>;
  name_translations?: Maybe<Array<TranslatedText>>;
  name_translationsCount?: Maybe<Scalars['Int']>;
  originalID?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};


export type FoodDescription_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type FoodDescription_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type FoodGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type FoodGameCountArgs = {
  where?: GameWhereInput;
};


export type FoodName_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type FoodName_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};

export type FoodCreateInput = {
  calories?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  hydration?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type FoodOrderByInput = {
  calories?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  hydration?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
  weight?: InputMaybe<OrderDirection>;
};

export type FoodUpdateArgs = {
  data: FoodUpdateInput;
  where: FoodWhereUniqueInput;
};

export type FoodUpdateInput = {
  calories?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  hydration?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type FoodWhereInput = {
  AND?: InputMaybe<Array<FoodWhereInput>>;
  NOT?: InputMaybe<Array<FoodWhereInput>>;
  OR?: InputMaybe<Array<FoodWhereInput>>;
  calories?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringFilter>;
  description_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  game?: InputMaybe<GameManyRelationFilter>;
  hydration?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  name_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  originalID?: InputMaybe<StringFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type FoodWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Game = {
  __typename?: 'Game';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type GameCreateInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type GameManyRelationFilter = {
  every?: InputMaybe<GameWhereInput>;
  none?: InputMaybe<GameWhereInput>;
  some?: InputMaybe<GameWhereInput>;
};

export type GameOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type GameRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GameWhereUniqueInput>>;
  create?: InputMaybe<Array<GameCreateInput>>;
};

export type GameRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GameWhereUniqueInput>>;
  create?: InputMaybe<Array<GameCreateInput>>;
  disconnect?: InputMaybe<Array<GameWhereUniqueInput>>;
  set?: InputMaybe<Array<GameWhereUniqueInput>>;
};

export type GameUpdateArgs = {
  data: GameUpdateInput;
  where: GameWhereUniqueInput;
};

export type GameUpdateInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type GameWhereInput = {
  AND?: InputMaybe<Array<GameWhereInput>>;
  NOT?: InputMaybe<Array<GameWhereInput>>;
  OR?: InputMaybe<Array<GameWhereInput>>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
};

export type GameWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Guide = {
  __typename?: 'Guide';
  content?: Maybe<Guide_Content_Document>;
  cover?: Maybe<ImageFieldOutput>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type GuideCreateInput = {
  content?: InputMaybe<Scalars['JSON']>;
  cover?: InputMaybe<ImageFieldInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type GuideOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type GuideUpdateArgs = {
  data: GuideUpdateInput;
  where: GuideWhereUniqueInput;
};

export type GuideUpdateInput = {
  content?: InputMaybe<Scalars['JSON']>;
  cover?: InputMaybe<ImageFieldInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type GuideWhereInput = {
  AND?: InputMaybe<Array<GuideWhereInput>>;
  NOT?: InputMaybe<Array<GuideWhereInput>>;
  OR?: InputMaybe<Array<GuideWhereInput>>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
};

export type GuideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Guide_Content_Document = {
  __typename?: 'Guide_content_Document';
  document: Scalars['JSON'];
};


export type Guide_Content_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ImageExtension {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type ImageFieldInput = {
  upload: Scalars['Upload'];
};

export type ImageFieldOutput = {
  __typename?: 'ImageFieldOutput';
  extension: ImageExtension;
  filesize: Scalars['Int'];
  height: Scalars['Int'];
  id: Scalars['ID'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fieldMeta?: Maybe<Scalars['JSON']>;
  isFilterable: Scalars['Boolean'];
  isOrderable: Scalars['Boolean'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean'];
  hideDelete: Scalars['Boolean'];
  initialColumns: Array<Scalars['String']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean'];
  isSingleton: Scalars['Boolean'];
  itemQueryName: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  labelField: Scalars['String'];
  listQueryName: Scalars['String'];
  pageSize: Scalars['Int'];
  path: Scalars['String'];
  plural: Scalars['String'];
  singular: Scalars['String'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type Map = {
  __typename?: 'Map';
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image1?: Maybe<ImageFieldOutput>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


export type MapGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type MapGameCountArgs = {
  where?: GameWhereInput;
};

export type MapCreateInput = {
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  height?: InputMaybe<Scalars['Int']>;
  image1?: InputMaybe<ImageFieldInput>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type MapGroup = {
  __typename?: 'MapGroup';
  id: Scalars['ID'];
  locations?: Maybe<Scalars['JSON']>;
  maps?: Maybe<Array<Map>>;
  mapsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type MapGroupMapsArgs = {
  orderBy?: Array<MapOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: MapWhereInput;
};


export type MapGroupMapsCountArgs = {
  where?: MapWhereInput;
};

export type MapGroupCreateInput = {
  locations?: InputMaybe<Scalars['JSON']>;
  maps?: InputMaybe<MapRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MapGroupManyRelationFilter = {
  every?: InputMaybe<MapGroupWhereInput>;
  none?: InputMaybe<MapGroupWhereInput>;
  some?: InputMaybe<MapGroupWhereInput>;
};

export type MapGroupOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type MapGroupRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<MapGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<MapGroupCreateInput>>;
};

export type MapGroupRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<MapGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<MapGroupCreateInput>>;
  disconnect?: InputMaybe<Array<MapGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<MapGroupWhereUniqueInput>>;
};

export type MapGroupUpdateArgs = {
  data: MapGroupUpdateInput;
  where: MapGroupWhereUniqueInput;
};

export type MapGroupUpdateInput = {
  locations?: InputMaybe<Scalars['JSON']>;
  maps?: InputMaybe<MapRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MapGroupWhereInput = {
  AND?: InputMaybe<Array<MapGroupWhereInput>>;
  NOT?: InputMaybe<Array<MapGroupWhereInput>>;
  OR?: InputMaybe<Array<MapGroupWhereInput>>;
  id?: InputMaybe<IdFilter>;
  maps?: InputMaybe<MapManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type MapGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type MapManyRelationFilter = {
  every?: InputMaybe<MapWhereInput>;
  none?: InputMaybe<MapWhereInput>;
  some?: InputMaybe<MapWhereInput>;
};

export type MapOrderByInput = {
  height?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
  url?: InputMaybe<OrderDirection>;
  width?: InputMaybe<OrderDirection>;
};

export type MapRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<MapWhereUniqueInput>>;
  create?: InputMaybe<Array<MapCreateInput>>;
};

export type MapRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<MapWhereUniqueInput>>;
  create?: InputMaybe<Array<MapCreateInput>>;
  disconnect?: InputMaybe<Array<MapWhereUniqueInput>>;
  set?: InputMaybe<Array<MapWhereUniqueInput>>;
};

export type MapUpdateArgs = {
  data: MapUpdateInput;
  where: MapWhereUniqueInput;
};

export type MapUpdateInput = {
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  height?: InputMaybe<Scalars['Int']>;
  image1?: InputMaybe<ImageFieldInput>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type MapWhereInput = {
  AND?: InputMaybe<Array<MapWhereInput>>;
  NOT?: InputMaybe<Array<MapWhereInput>>;
  OR?: InputMaybe<Array<MapWhereInput>>;
  game?: InputMaybe<GameManyRelationFilter>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  width?: InputMaybe<IntNullableFilter>;
};

export type MapWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Material = {
  __typename?: 'Material';
  description?: Maybe<Scalars['String']>;
  description_translations?: Maybe<Array<TranslatedText>>;
  description_translationsCount?: Maybe<Scalars['Int']>;
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']>;
  name_translations?: Maybe<Array<TranslatedText>>;
  name_translationsCount?: Maybe<Scalars['Int']>;
  originalID?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};


export type MaterialDescription_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type MaterialDescription_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type MaterialGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type MaterialGameCountArgs = {
  where?: GameWhereInput;
};


export type MaterialName_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type MaterialName_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};

export type MaterialCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type MaterialOrderByInput = {
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
  weight?: InputMaybe<OrderDirection>;
};

export type MaterialUpdateArgs = {
  data: MaterialUpdateInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type MaterialWhereInput = {
  AND?: InputMaybe<Array<MaterialWhereInput>>;
  NOT?: InputMaybe<Array<MaterialWhereInput>>;
  OR?: InputMaybe<Array<MaterialWhereInput>>;
  description?: InputMaybe<StringFilter>;
  description_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  game?: InputMaybe<GameManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  name_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  originalID?: InputMaybe<StringFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type MaterialWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticateUserWithPassword?: Maybe<UserAuthenticationWithPasswordResult>;
  createClothe?: Maybe<Clothe>;
  createClothes?: Maybe<Array<Maybe<Clothe>>>;
  createFirstAid?: Maybe<FirstAid>;
  createFirstAids?: Maybe<Array<Maybe<FirstAid>>>;
  createFood?: Maybe<Food>;
  createFoods?: Maybe<Array<Maybe<Food>>>;
  createGame?: Maybe<Game>;
  createGames?: Maybe<Array<Maybe<Game>>>;
  createGuide?: Maybe<Guide>;
  createGuides?: Maybe<Array<Maybe<Guide>>>;
  createInitialUser: UserAuthenticationWithPasswordSuccess;
  createMap?: Maybe<Map>;
  createMapGroup?: Maybe<MapGroup>;
  createMapGroups?: Maybe<Array<Maybe<MapGroup>>>;
  createMaps?: Maybe<Array<Maybe<Map>>>;
  createMaterial?: Maybe<Material>;
  createMaterials?: Maybe<Array<Maybe<Material>>>;
  createRegion?: Maybe<Region>;
  createRegions?: Maybe<Array<Maybe<Region>>>;
  createTool?: Maybe<Tool>;
  createTools?: Maybe<Array<Maybe<Tool>>>;
  createTranslatedText?: Maybe<TranslatedText>;
  createTranslatedTexts?: Maybe<Array<Maybe<TranslatedText>>>;
  createUser?: Maybe<User>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  deleteClothe?: Maybe<Clothe>;
  deleteClothes?: Maybe<Array<Maybe<Clothe>>>;
  deleteFirstAid?: Maybe<FirstAid>;
  deleteFirstAids?: Maybe<Array<Maybe<FirstAid>>>;
  deleteFood?: Maybe<Food>;
  deleteFoods?: Maybe<Array<Maybe<Food>>>;
  deleteGame?: Maybe<Game>;
  deleteGames?: Maybe<Array<Maybe<Game>>>;
  deleteGuide?: Maybe<Guide>;
  deleteGuides?: Maybe<Array<Maybe<Guide>>>;
  deleteMap?: Maybe<Map>;
  deleteMapGroup?: Maybe<MapGroup>;
  deleteMapGroups?: Maybe<Array<Maybe<MapGroup>>>;
  deleteMaps?: Maybe<Array<Maybe<Map>>>;
  deleteMaterial?: Maybe<Material>;
  deleteMaterials?: Maybe<Array<Maybe<Material>>>;
  deleteRegion?: Maybe<Region>;
  deleteRegions?: Maybe<Array<Maybe<Region>>>;
  deleteTool?: Maybe<Tool>;
  deleteTools?: Maybe<Array<Maybe<Tool>>>;
  deleteTranslatedText?: Maybe<TranslatedText>;
  deleteTranslatedTexts?: Maybe<Array<Maybe<TranslatedText>>>;
  deleteUser?: Maybe<User>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  endSession: Scalars['Boolean'];
  updateClothe?: Maybe<Clothe>;
  updateClothes?: Maybe<Array<Maybe<Clothe>>>;
  updateFirstAid?: Maybe<FirstAid>;
  updateFirstAids?: Maybe<Array<Maybe<FirstAid>>>;
  updateFood?: Maybe<Food>;
  updateFoods?: Maybe<Array<Maybe<Food>>>;
  updateGame?: Maybe<Game>;
  updateGames?: Maybe<Array<Maybe<Game>>>;
  updateGuide?: Maybe<Guide>;
  updateGuides?: Maybe<Array<Maybe<Guide>>>;
  updateMap?: Maybe<Map>;
  updateMapGroup?: Maybe<MapGroup>;
  updateMapGroups?: Maybe<Array<Maybe<MapGroup>>>;
  updateMaps?: Maybe<Array<Maybe<Map>>>;
  updateMaterial?: Maybe<Material>;
  updateMaterials?: Maybe<Array<Maybe<Material>>>;
  updateRegion?: Maybe<Region>;
  updateRegions?: Maybe<Array<Maybe<Region>>>;
  updateTool?: Maybe<Tool>;
  updateTools?: Maybe<Array<Maybe<Tool>>>;
  updateTranslatedText?: Maybe<TranslatedText>;
  updateTranslatedTexts?: Maybe<Array<Maybe<TranslatedText>>>;
  updateUser?: Maybe<User>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
};


export type MutationAuthenticateUserWithPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateClotheArgs = {
  data: ClotheCreateInput;
};


export type MutationCreateClothesArgs = {
  data: Array<ClotheCreateInput>;
};


export type MutationCreateFirstAidArgs = {
  data: FirstAidCreateInput;
};


export type MutationCreateFirstAidsArgs = {
  data: Array<FirstAidCreateInput>;
};


export type MutationCreateFoodArgs = {
  data: FoodCreateInput;
};


export type MutationCreateFoodsArgs = {
  data: Array<FoodCreateInput>;
};


export type MutationCreateGameArgs = {
  data: GameCreateInput;
};


export type MutationCreateGamesArgs = {
  data: Array<GameCreateInput>;
};


export type MutationCreateGuideArgs = {
  data: GuideCreateInput;
};


export type MutationCreateGuidesArgs = {
  data: Array<GuideCreateInput>;
};


export type MutationCreateInitialUserArgs = {
  data: CreateInitialUserInput;
};


export type MutationCreateMapArgs = {
  data: MapCreateInput;
};


export type MutationCreateMapGroupArgs = {
  data: MapGroupCreateInput;
};


export type MutationCreateMapGroupsArgs = {
  data: Array<MapGroupCreateInput>;
};


export type MutationCreateMapsArgs = {
  data: Array<MapCreateInput>;
};


export type MutationCreateMaterialArgs = {
  data: MaterialCreateInput;
};


export type MutationCreateMaterialsArgs = {
  data: Array<MaterialCreateInput>;
};


export type MutationCreateRegionArgs = {
  data: RegionCreateInput;
};


export type MutationCreateRegionsArgs = {
  data: Array<RegionCreateInput>;
};


export type MutationCreateToolArgs = {
  data: ToolCreateInput;
};


export type MutationCreateToolsArgs = {
  data: Array<ToolCreateInput>;
};


export type MutationCreateTranslatedTextArgs = {
  data: TranslatedTextCreateInput;
};


export type MutationCreateTranslatedTextsArgs = {
  data: Array<TranslatedTextCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationDeleteClotheArgs = {
  where: ClotheWhereUniqueInput;
};


export type MutationDeleteClothesArgs = {
  where: Array<ClotheWhereUniqueInput>;
};


export type MutationDeleteFirstAidArgs = {
  where: FirstAidWhereUniqueInput;
};


export type MutationDeleteFirstAidsArgs = {
  where: Array<FirstAidWhereUniqueInput>;
};


export type MutationDeleteFoodArgs = {
  where: FoodWhereUniqueInput;
};


export type MutationDeleteFoodsArgs = {
  where: Array<FoodWhereUniqueInput>;
};


export type MutationDeleteGameArgs = {
  where: GameWhereUniqueInput;
};


export type MutationDeleteGamesArgs = {
  where: Array<GameWhereUniqueInput>;
};


export type MutationDeleteGuideArgs = {
  where: GuideWhereUniqueInput;
};


export type MutationDeleteGuidesArgs = {
  where: Array<GuideWhereUniqueInput>;
};


export type MutationDeleteMapArgs = {
  where: MapWhereUniqueInput;
};


export type MutationDeleteMapGroupArgs = {
  where: MapGroupWhereUniqueInput;
};


export type MutationDeleteMapGroupsArgs = {
  where: Array<MapGroupWhereUniqueInput>;
};


export type MutationDeleteMapsArgs = {
  where: Array<MapWhereUniqueInput>;
};


export type MutationDeleteMaterialArgs = {
  where: MaterialWhereUniqueInput;
};


export type MutationDeleteMaterialsArgs = {
  where: Array<MaterialWhereUniqueInput>;
};


export type MutationDeleteRegionArgs = {
  where: RegionWhereUniqueInput;
};


export type MutationDeleteRegionsArgs = {
  where: Array<RegionWhereUniqueInput>;
};


export type MutationDeleteToolArgs = {
  where: ToolWhereUniqueInput;
};


export type MutationDeleteToolsArgs = {
  where: Array<ToolWhereUniqueInput>;
};


export type MutationDeleteTranslatedTextArgs = {
  where: TranslatedTextWhereUniqueInput;
};


export type MutationDeleteTranslatedTextsArgs = {
  where: Array<TranslatedTextWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationUpdateClotheArgs = {
  data: ClotheUpdateInput;
  where: ClotheWhereUniqueInput;
};


export type MutationUpdateClothesArgs = {
  data: Array<ClotheUpdateArgs>;
};


export type MutationUpdateFirstAidArgs = {
  data: FirstAidUpdateInput;
  where: FirstAidWhereUniqueInput;
};


export type MutationUpdateFirstAidsArgs = {
  data: Array<FirstAidUpdateArgs>;
};


export type MutationUpdateFoodArgs = {
  data: FoodUpdateInput;
  where: FoodWhereUniqueInput;
};


export type MutationUpdateFoodsArgs = {
  data: Array<FoodUpdateArgs>;
};


export type MutationUpdateGameArgs = {
  data: GameUpdateInput;
  where: GameWhereUniqueInput;
};


export type MutationUpdateGamesArgs = {
  data: Array<GameUpdateArgs>;
};


export type MutationUpdateGuideArgs = {
  data: GuideUpdateInput;
  where: GuideWhereUniqueInput;
};


export type MutationUpdateGuidesArgs = {
  data: Array<GuideUpdateArgs>;
};


export type MutationUpdateMapArgs = {
  data: MapUpdateInput;
  where: MapWhereUniqueInput;
};


export type MutationUpdateMapGroupArgs = {
  data: MapGroupUpdateInput;
  where: MapGroupWhereUniqueInput;
};


export type MutationUpdateMapGroupsArgs = {
  data: Array<MapGroupUpdateArgs>;
};


export type MutationUpdateMapsArgs = {
  data: Array<MapUpdateArgs>;
};


export type MutationUpdateMaterialArgs = {
  data: MaterialUpdateInput;
  where: MaterialWhereUniqueInput;
};


export type MutationUpdateMaterialsArgs = {
  data: Array<MaterialUpdateArgs>;
};


export type MutationUpdateRegionArgs = {
  data: RegionUpdateInput;
  where: RegionWhereUniqueInput;
};


export type MutationUpdateRegionsArgs = {
  data: Array<RegionUpdateArgs>;
};


export type MutationUpdateToolArgs = {
  data: ToolUpdateInput;
  where: ToolWhereUniqueInput;
};


export type MutationUpdateToolsArgs = {
  data: Array<ToolUpdateArgs>;
};


export type MutationUpdateTranslatedTextArgs = {
  data: TranslatedTextUpdateInput;
  where: TranslatedTextWhereUniqueInput;
};


export type MutationUpdateTranslatedTextsArgs = {
  data: Array<TranslatedTextUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  authenticatedItem?: Maybe<AuthenticatedItem>;
  clothe?: Maybe<Clothe>;
  clothes?: Maybe<Array<Clothe>>;
  clothesCount?: Maybe<Scalars['Int']>;
  firstAid?: Maybe<FirstAid>;
  firstAids?: Maybe<Array<FirstAid>>;
  firstAidsCount?: Maybe<Scalars['Int']>;
  food?: Maybe<Food>;
  foods?: Maybe<Array<Food>>;
  foodsCount?: Maybe<Scalars['Int']>;
  game?: Maybe<Game>;
  games?: Maybe<Array<Game>>;
  gamesCount?: Maybe<Scalars['Int']>;
  guide?: Maybe<Guide>;
  guides?: Maybe<Array<Guide>>;
  guidesCount?: Maybe<Scalars['Int']>;
  keystone: KeystoneMeta;
  map?: Maybe<Map>;
  mapGroup?: Maybe<MapGroup>;
  mapGroups?: Maybe<Array<MapGroup>>;
  mapGroupsCount?: Maybe<Scalars['Int']>;
  maps?: Maybe<Array<Map>>;
  mapsCount?: Maybe<Scalars['Int']>;
  material?: Maybe<Material>;
  materials?: Maybe<Array<Material>>;
  materialsCount?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  regions?: Maybe<Array<Region>>;
  regionsCount?: Maybe<Scalars['Int']>;
  tool?: Maybe<Tool>;
  tools?: Maybe<Array<Tool>>;
  toolsCount?: Maybe<Scalars['Int']>;
  translatedText?: Maybe<TranslatedText>;
  translatedTexts?: Maybe<Array<TranslatedText>>;
  translatedTextsCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']>;
};


export type QueryClotheArgs = {
  where: ClotheWhereUniqueInput;
};


export type QueryClothesArgs = {
  orderBy?: Array<ClotheOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ClotheWhereInput;
};


export type QueryClothesCountArgs = {
  where?: ClotheWhereInput;
};


export type QueryFirstAidArgs = {
  where: FirstAidWhereUniqueInput;
};


export type QueryFirstAidsArgs = {
  orderBy?: Array<FirstAidOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FirstAidWhereInput;
};


export type QueryFirstAidsCountArgs = {
  where?: FirstAidWhereInput;
};


export type QueryFoodArgs = {
  where: FoodWhereUniqueInput;
};


export type QueryFoodsArgs = {
  orderBy?: Array<FoodOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: FoodWhereInput;
};


export type QueryFoodsCountArgs = {
  where?: FoodWhereInput;
};


export type QueryGameArgs = {
  where: GameWhereUniqueInput;
};


export type QueryGamesArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type QueryGamesCountArgs = {
  where?: GameWhereInput;
};


export type QueryGuideArgs = {
  where: GuideWhereUniqueInput;
};


export type QueryGuidesArgs = {
  orderBy?: Array<GuideOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GuideWhereInput;
};


export type QueryGuidesCountArgs = {
  where?: GuideWhereInput;
};


export type QueryMapArgs = {
  where: MapWhereUniqueInput;
};


export type QueryMapGroupArgs = {
  where: MapGroupWhereUniqueInput;
};


export type QueryMapGroupsArgs = {
  orderBy?: Array<MapGroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: MapGroupWhereInput;
};


export type QueryMapGroupsCountArgs = {
  where?: MapGroupWhereInput;
};


export type QueryMapsArgs = {
  orderBy?: Array<MapOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: MapWhereInput;
};


export type QueryMapsCountArgs = {
  where?: MapWhereInput;
};


export type QueryMaterialArgs = {
  where: MaterialWhereUniqueInput;
};


export type QueryMaterialsArgs = {
  orderBy?: Array<MaterialOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: MaterialWhereInput;
};


export type QueryMaterialsCountArgs = {
  where?: MaterialWhereInput;
};


export type QueryRegionArgs = {
  where: RegionWhereUniqueInput;
};


export type QueryRegionsArgs = {
  orderBy?: Array<RegionOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: RegionWhereInput;
};


export type QueryRegionsCountArgs = {
  where?: RegionWhereInput;
};


export type QueryToolArgs = {
  where: ToolWhereUniqueInput;
};


export type QueryToolsArgs = {
  orderBy?: Array<ToolOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: ToolWhereInput;
};


export type QueryToolsCountArgs = {
  where?: ToolWhereInput;
};


export type QueryTranslatedTextArgs = {
  where: TranslatedTextWhereUniqueInput;
};


export type QueryTranslatedTextsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type QueryTranslatedTextsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Region = {
  __typename?: 'Region';
  cover_image?: Maybe<ImageFieldOutput>;
  id: Scalars['ID'];
  mapGroups?: Maybe<Array<MapGroup>>;
  mapGroupsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_key?: Maybe<Scalars['String']>;
  originalID?: Maybe<Scalars['String']>;
};


export type RegionMapGroupsArgs = {
  orderBy?: Array<MapGroupOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: MapGroupWhereInput;
};


export type RegionMapGroupsCountArgs = {
  where?: MapGroupWhereInput;
};

export type RegionCreateInput = {
  cover_image?: InputMaybe<ImageFieldInput>;
  mapGroups?: InputMaybe<MapGroupRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']>;
  name_key?: InputMaybe<Scalars['String']>;
  originalID?: InputMaybe<Scalars['String']>;
};

export type RegionOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  name_key?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
};

export type RegionUpdateArgs = {
  data: RegionUpdateInput;
  where: RegionWhereUniqueInput;
};

export type RegionUpdateInput = {
  cover_image?: InputMaybe<ImageFieldInput>;
  mapGroups?: InputMaybe<MapGroupRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  name_key?: InputMaybe<Scalars['String']>;
  originalID?: InputMaybe<Scalars['String']>;
};

export type RegionWhereInput = {
  AND?: InputMaybe<Array<RegionWhereInput>>;
  NOT?: InputMaybe<Array<RegionWhereInput>>;
  OR?: InputMaybe<Array<RegionWhereInput>>;
  id?: InputMaybe<IdFilter>;
  mapGroups?: InputMaybe<MapGroupManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  name_key?: InputMaybe<StringFilter>;
  originalID?: InputMaybe<StringFilter>;
};

export type RegionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Tool = {
  __typename?: 'Tool';
  comment?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_translations?: Maybe<Array<TranslatedText>>;
  description_translationsCount?: Maybe<Scalars['Int']>;
  game?: Maybe<Array<Game>>;
  gameCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']>;
  name_translations?: Maybe<Array<TranslatedText>>;
  name_translationsCount?: Maybe<Scalars['Int']>;
  originalID?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};


export type ToolDescription_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type ToolDescription_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};


export type ToolGameArgs = {
  orderBy?: Array<GameOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: GameWhereInput;
};


export type ToolGameCountArgs = {
  where?: GameWhereInput;
};


export type ToolName_TranslationsArgs = {
  orderBy?: Array<TranslatedTextOrderByInput>;
  skip?: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  where?: TranslatedTextWhereInput;
};


export type ToolName_TranslationsCountArgs = {
  where?: TranslatedTextWhereInput;
};

export type ToolCreateInput = {
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  game?: InputMaybe<GameRelateToManyForCreateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForCreateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ToolOrderByInput = {
  comment?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  originalID?: InputMaybe<OrderDirection>;
  weight?: InputMaybe<OrderDirection>;
};

export type ToolUpdateArgs = {
  data: ToolUpdateInput;
  where: ToolWhereUniqueInput;
};

export type ToolUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  description_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  game?: InputMaybe<GameRelateToManyForUpdateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  name_translations?: InputMaybe<TranslatedTextRelateToManyForUpdateInput>;
  originalID?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ToolWhereInput = {
  AND?: InputMaybe<Array<ToolWhereInput>>;
  NOT?: InputMaybe<Array<ToolWhereInput>>;
  OR?: InputMaybe<Array<ToolWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  description_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  game?: InputMaybe<GameManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  name_translations?: InputMaybe<TranslatedTextManyRelationFilter>;
  originalID?: InputMaybe<StringFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type ToolWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type TranslatedText = {
  __typename?: 'TranslatedText';
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type TranslatedTextCreateInput = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type TranslatedTextManyRelationFilter = {
  every?: InputMaybe<TranslatedTextWhereInput>;
  none?: InputMaybe<TranslatedTextWhereInput>;
  some?: InputMaybe<TranslatedTextWhereInput>;
};

export type TranslatedTextOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  locale?: InputMaybe<OrderDirection>;
  text?: InputMaybe<OrderDirection>;
};

export type TranslatedTextRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<TranslatedTextWhereUniqueInput>>;
  create?: InputMaybe<Array<TranslatedTextCreateInput>>;
};

export type TranslatedTextRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<TranslatedTextWhereUniqueInput>>;
  create?: InputMaybe<Array<TranslatedTextCreateInput>>;
  disconnect?: InputMaybe<Array<TranslatedTextWhereUniqueInput>>;
  set?: InputMaybe<Array<TranslatedTextWhereUniqueInput>>;
};

export type TranslatedTextUpdateArgs = {
  data: TranslatedTextUpdateInput;
  where: TranslatedTextWhereUniqueInput;
};

export type TranslatedTextUpdateInput = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type TranslatedTextWhereInput = {
  AND?: InputMaybe<Array<TranslatedTextWhereInput>>;
  NOT?: InputMaybe<Array<TranslatedTextWhereInput>>;
  OR?: InputMaybe<Array<TranslatedTextWhereInput>>;
  id?: InputMaybe<IdFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringFilter>;
};

export type TranslatedTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<PasswordState>;
};

export type UserAuthenticationWithPasswordFailure = {
  __typename?: 'UserAuthenticationWithPasswordFailure';
  message: Scalars['String'];
};

export type UserAuthenticationWithPasswordResult = UserAuthenticationWithPasswordFailure | UserAuthenticationWithPasswordSuccess;

export type UserAuthenticationWithPasswordSuccess = {
  __typename?: 'UserAuthenticationWithPasswordSuccess';
  item: User;
  sessionToken: Scalars['String'];
};

export type UserCreateInput = {
  email?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserOrderByInput = {
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type GetClothesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GetClothesQuery = { __typename?: 'Query', head?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, chest?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, jacket?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, hand?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, leg?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, feet?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, shoe?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null, accessory?: Array<{ __typename?: 'Clothe', id: string, weight?: number | null, description?: string | null, originalID?: string | null, warmth?: number | null, windproof?: number | null, protection?: number | null, waterproof?: number | null, mobility?: number | null, type?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null };

export type GetFirstAidQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GetFirstAidQuery = { __typename?: 'Query', firstAids?: Array<{ __typename?: 'FirstAid', id: string, name?: string | null, description?: string | null, weight?: number | null, prevents_description?: string | null, effect_description?: string | null, treats_description?: string | null, originalID?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null };

export type GetFoodQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GetFoodQuery = { __typename?: 'Query', foods?: Array<{ __typename?: 'Food', id: string, name?: string | null, weight?: number | null, description?: string | null, originalID?: string | null, calories?: number | null, hydration?: number | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null };

export type GetMaterialsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GetMaterialsQuery = { __typename?: 'Query', materials?: Array<{ __typename?: 'Material', id: string, name?: string | null, description?: string | null, weight?: number | null, originalID?: string | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null };

export type GetToolsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;


export type GetToolsQuery = { __typename?: 'Query', tools?: Array<{ __typename?: 'Tool', id: string, name?: string | null, description?: string | null, weight?: number | null, originalID?: string | null, comment?: string | null, description_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, name_translations?: Array<{ __typename?: 'TranslatedText', text?: string | null }> | null, image?: { __typename?: 'ImageFieldOutput', url: string, filesize: number } | null }> | null };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, name_key?: string | null, originalID?: string | null, cover_image?: { __typename?: 'ImageFieldOutput', url: string } | null }> | null };


export const GetClothesDocument = gql`
    query GetClothes($locale: String) {
  head: clothes(orderBy: {name: asc}, where: {type: {equals: "head"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  chest: clothes(orderBy: {name: asc}, where: {type: {equals: "chest"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  jacket: clothes(orderBy: {name: asc}, where: {type: {equals: "jacket"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  hand: clothes(orderBy: {name: asc}, where: {type: {equals: "hand"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  leg: clothes(orderBy: {name: asc}, where: {type: {equals: "leg"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  feet: clothes(orderBy: {name: asc}, where: {type: {equals: "feet"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  shoe: clothes(orderBy: {name: asc}, where: {type: {equals: "shoe"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
  accessory: clothes(orderBy: {name: asc}, where: {type: {equals: "accessory"}}) {
    id
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    warmth
    windproof
    protection
    waterproof
    mobility
    type
  }
}
    `;

/**
 * __useGetClothesQuery__
 *
 * To run a query within a React component, call `useGetClothesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClothesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClothesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetClothesQuery(baseOptions?: Apollo.QueryHookOptions<GetClothesQuery, GetClothesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClothesQuery, GetClothesQueryVariables>(GetClothesDocument, options);
      }
export function useGetClothesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClothesQuery, GetClothesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClothesQuery, GetClothesQueryVariables>(GetClothesDocument, options);
        }
export type GetClothesQueryHookResult = ReturnType<typeof useGetClothesQuery>;
export type GetClothesLazyQueryHookResult = ReturnType<typeof useGetClothesLazyQuery>;
export type GetClothesQueryResult = Apollo.QueryResult<GetClothesQuery, GetClothesQueryVariables>;
export const GetFirstAidDocument = gql`
    query GetFirstAid($locale: String) {
  firstAids(orderBy: {name: asc}) {
    id
    name
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    description
    weight
    prevents_description
    effect_description
    treats_description
    originalID
    image {
      url
      filesize
    }
  }
}
    `;

/**
 * __useGetFirstAidQuery__
 *
 * To run a query within a React component, call `useGetFirstAidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstAidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstAidQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFirstAidQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstAidQuery, GetFirstAidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstAidQuery, GetFirstAidQueryVariables>(GetFirstAidDocument, options);
      }
export function useGetFirstAidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstAidQuery, GetFirstAidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstAidQuery, GetFirstAidQueryVariables>(GetFirstAidDocument, options);
        }
export type GetFirstAidQueryHookResult = ReturnType<typeof useGetFirstAidQuery>;
export type GetFirstAidLazyQueryHookResult = ReturnType<typeof useGetFirstAidLazyQuery>;
export type GetFirstAidQueryResult = Apollo.QueryResult<GetFirstAidQuery, GetFirstAidQueryVariables>;
export const GetFoodDocument = gql`
    query GetFood($locale: String) {
  foods(orderBy: {name: asc}) {
    id
    name
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    description
    originalID
    image {
      url
      filesize
    }
    calories
    hydration
  }
}
    `;

/**
 * __useGetFoodQuery__
 *
 * To run a query within a React component, call `useGetFoodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetFoodQuery(baseOptions?: Apollo.QueryHookOptions<GetFoodQuery, GetFoodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoodQuery, GetFoodQueryVariables>(GetFoodDocument, options);
      }
export function useGetFoodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoodQuery, GetFoodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoodQuery, GetFoodQueryVariables>(GetFoodDocument, options);
        }
export type GetFoodQueryHookResult = ReturnType<typeof useGetFoodQuery>;
export type GetFoodLazyQueryHookResult = ReturnType<typeof useGetFoodLazyQuery>;
export type GetFoodQueryResult = Apollo.QueryResult<GetFoodQuery, GetFoodQueryVariables>;
export const GetMaterialsDocument = gql`
    query GetMaterials($locale: String) {
  materials(orderBy: {name: asc}) {
    id
    name
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    description
    weight
    originalID
    image {
      url
      filesize
    }
  }
}
    `;

/**
 * __useGetMaterialsQuery__
 *
 * To run a query within a React component, call `useGetMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialsQuery, GetMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsQuery, GetMaterialsQueryVariables>(GetMaterialsDocument, options);
      }
export function useGetMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsQuery, GetMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsQuery, GetMaterialsQueryVariables>(GetMaterialsDocument, options);
        }
export type GetMaterialsQueryHookResult = ReturnType<typeof useGetMaterialsQuery>;
export type GetMaterialsLazyQueryHookResult = ReturnType<typeof useGetMaterialsLazyQuery>;
export type GetMaterialsQueryResult = Apollo.QueryResult<GetMaterialsQuery, GetMaterialsQueryVariables>;
export const GetToolsDocument = gql`
    query GetTools($locale: String) {
  tools(orderBy: {name: asc}) {
    id
    name
    description
    description_translations(where: {locale: {equals: $locale}}) {
      text
    }
    name_translations(where: {locale: {equals: $locale}}) {
      text
    }
    weight
    originalID
    image {
      url
      filesize
    }
    comment
  }
}
    `;

/**
 * __useGetToolsQuery__
 *
 * To run a query within a React component, call `useGetToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetToolsQuery(baseOptions?: Apollo.QueryHookOptions<GetToolsQuery, GetToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, options);
      }
export function useGetToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToolsQuery, GetToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, options);
        }
export type GetToolsQueryHookResult = ReturnType<typeof useGetToolsQuery>;
export type GetToolsLazyQueryHookResult = ReturnType<typeof useGetToolsLazyQuery>;
export type GetToolsQueryResult = Apollo.QueryResult<GetToolsQuery, GetToolsQueryVariables>;
export const GetRegionsDocument = gql`
    query GetRegions {
  regions(orderBy: {name: asc}) {
    cover_image {
      url
    }
    id
    name
    name_key
    originalID
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;